import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import "./loginpage.scss";
import Login from "../../components/login/Login";
import LoginMobile from "../../components/login/LoginMobile";

const LoginPage = (props) => {
  useEffect(() => {
    document.title = "Login";
  }, []);
  return (
    <Fragment>
      <div className="login-page-desktop">
        {props.width === "sm" ? <LoginMobile /> : <Login />}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    width: state.layout.screenWidth,
  };
};

export default withRouter(connect(mapStateToProps)(LoginPage));
